var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoinflip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_56_11870)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.85 14C27.85 21.6491 21.6491 27.85 14 27.85C6.35086 27.85 0.15 21.6491 0.15 14C0.15 6.35086 6.35086 0.15 14 0.15C21.6491 0.15 27.85 6.35086 27.85 14Z",
    stroke: "#9D3CA5",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 27.5C14 27.7761 14.224 28.0009 14.5 27.9911C17.7141 27.8763 20.7915 26.6579 23.2131 24.5413C23.421 24.3596 23.4304 24.0424 23.2414 23.8411L22.2456 22.7807C22.0566 22.5794 21.7408 22.5704 21.5316 22.7505C19.567 24.4416 17.0896 25.4224 14.4999 25.5346C14.224 25.5465 14 25.7692 14 26.0454V27.5Z",
    fill: "#9D3CA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6912 7.25005C25.9303 7.11198 26.013 6.80557 25.8665 6.57151C24.16 3.84537 21.5661 1.78949 18.5224 0.75063C18.261 0.661433 17.9816 0.811877 17.9018 1.07624L17.4813 2.46876C17.4015 2.73312 17.5516 3.01109 17.8123 3.10226C20.259 3.95814 22.3471 5.61316 23.7391 7.79984C23.8874 8.03279 24.1923 8.11543 24.4315 7.97736L25.6912 7.25005Z",
    fill: "#9D3CA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 0.500056C14 0.223914 13.776 -0.00087443 13.5 0.00897905C10.2859 0.123753 7.20846 1.34217 4.78689 3.45873C4.57897 3.64046 4.56954 3.95768 4.75858 4.15898L5.75433 5.21935C5.94336 5.42064 6.25913 5.42966 6.46842 5.24951C8.43301 3.55849 10.9104 2.57764 13.5001 2.46548C13.776 2.45353 14 2.23081 14 1.95466V0.500056Z",
    fill: "#9D3CA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.30857 7.24996C2.06942 7.11189 1.76274 7.19351 1.63329 7.43743C0.125619 10.2784 -0.357889 13.5527 0.264321 16.7081C0.317744 16.979 0.587749 17.1458 0.856596 17.0827L2.27277 16.7506C2.54162 16.6875 2.70731 16.4186 2.65594 16.1472C2.17377 13.6003 2.563 10.9645 3.76073 8.6656C3.88832 8.4207 3.80744 8.11534 3.5683 7.97727L2.30857 7.24996Z",
    fill: "#9D3CA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.30855 20.75C2.0694 20.8881 1.98674 21.1945 2.13326 21.4285C3.83972 24.1547 6.4336 26.2105 9.47737 27.2494C9.73871 27.3386 10.0182 27.1882 10.098 26.9238L10.5184 25.5313C10.5982 25.2669 10.4482 24.989 10.1875 24.8978C7.74071 24.0419 5.65259 22.3869 4.2606 20.2002C4.11232 19.9673 3.80742 19.8846 3.56827 20.0227L2.30855 20.75Z",
    fill: "#9D3CA5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8309 6.53809L16.5849 10.3285L20.1764 10.7192C20.9868 10.8076 21.293 11.8512 20.6642 12.3818L17.8036 14.7961L18.6904 18.8501C18.8674 19.66 18.0082 20.2914 17.3155 19.8603L14 17.7972L10.6846 19.8603C9.99155 20.2914 9.13271 19.66 9.3097 18.8501L10.1962 14.7961L7.33557 12.3818C6.70712 11.8512 7.01327 10.8076 7.82335 10.7192L11.4152 10.3285L13.1692 6.53809C13.5011 5.82064 14.4987 5.82064 14.8309 6.53809Z",
    fill: "#9D3CA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6914 20.75C25.9306 20.8881 26.2373 20.8065 26.3667 20.5625C27.8744 17.7216 28.3579 14.4473 27.7357 11.2919C27.6822 11.021 27.4122 10.8542 27.1434 10.9173L25.7272 11.2494C25.4584 11.3125 25.2927 11.5814 25.344 11.8528C25.8262 14.3997 25.437 17.0355 24.2393 19.3344C24.1117 19.5793 24.1925 19.8846 24.4317 20.0227L25.6914 20.75Z",
    fill: "#9D3CA5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_56_11870"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinflip);
export default __webpack_public_path__ + "static/media/coinflip.a8a66c4620af7a25b6bead177b8713ca.svg";
export { ForwardRef as ReactComponent };